import {
  CALL_API,
  REQUEST_GET,
  REQUEST_POST,
  REQUEST_PUT,
  REQUEST_DELETE
} from '../middleware/api'
import { COMPANY, COMPANY_COLLECTION, NONE } from '../schemas'
import { ERROR, SUCCESS } from '../components/AlertListItem'

export const CREATE_COMPANY_REQUEST = 'tru/companies/CREATE_COMPANY_REQUEST'
export const CREATE_COMPANY_SUCCEEDED = 'tru/companies/CREATE_COMPANY_SUCCEEDED'
export const CREATE_COMPANY_FAILED = 'tru/companies/CREATE_COMPANY_FAILED'
export const FETCH_COMPANIES_REQUEST = 'tru/companies/FETCH_COMPANIES_REQUEST'
export const FETCH_COMPANIES_SUCCEEDED =
  'tru/companies/FETCH_COMPANIES_SUCCEEDED'
export const FETCH_COMPANIES_FAILED = 'tru/companies/FETCH_COMPANIES_FAILED'
export const UPDATE_COMPANY_REQUEST = 'tru/companies/UPDATE_COMPANY_REQUEST'
export const UPDATE_COMPANY_SUCCEEDED = 'tru/companies/UPDATE_COMPANY_SUCCEEDED'
export const UPDATE_COMPANY_FAILED = 'tru/companies/UPDATE_COMPANY_FAILED'
export const REMOVE_WORD_CLOUD_REQUEST =
  'tru/companies/REMOVE_WORD_CLOUD_REQUEST'
export const REMOVE_WORD_CLOUD_SUCCEEDED =
  'tru/companies/REMOVE_WORD_CLOUD_SUCCEEDED'
export const REMOVE_WORD_CLOUD_FAILED = 'tru/companies/REMOVE_WORD_CLOUD_FAILED'
export const SUBMIT_WORD_CLOUD_REQUEST =
  'tru/companies/SUBMIT_WORD_CLOUD_REQUEST'
export const SUBMIT_WORD_CLOUD_SUCCEEDED =
  'tru/companies/SUBMIT_WORD_CLOUD_SUCCEEDED'
export const SUBMIT_WORD_CLOUD_FAILED = 'tru/companies/SUBMIT_WORD_CLOUD_FAILED'

export const createCompany = attributes => ({
  [CREATE_COMPANY_FAILED]: error => ({
    alert: {
      type: ERROR,
      message: error.error[0],
      scope: 'createCompanyError'
    }
  }),
  [CREATE_COMPANY_SUCCEEDED]: {
    alert: {
      type: SUCCESS,
      message: 'Company successfully created',
      scope: 'createCompanySuccess'
    }
  },
  [CALL_API]: {
    types: [
      CREATE_COMPANY_REQUEST,
      CREATE_COMPANY_SUCCEEDED,
      CREATE_COMPANY_FAILED
    ],
    endpoint: `companies.json`,
    requestType: REQUEST_POST,
    data: { company: attributes },
    schema: COMPANY
  }
})

const updateCompanyRequest = (id, attributes) => ({
  [UPDATE_COMPANY_SUCCEEDED]: {
    alert: {
      type: SUCCESS,
      message: 'Settings have been updated.'
    }
  },
  [UPDATE_COMPANY_FAILED]: {
    alert: {
      type: ERROR,
      message:
        'There was a problem updating the company settings. Please try again.'
    }
  },
  [CALL_API]: {
    types: [
      UPDATE_COMPANY_REQUEST,
      UPDATE_COMPANY_SUCCEEDED,
      UPDATE_COMPANY_FAILED
    ],
    endpoint: `companies/${id}.json`,
    requestType: REQUEST_PUT,
    data: { company: attributes },
    schema: NONE
  }
})

export const submitWordCloudRequest = () => ({
  type: SUBMIT_WORD_CLOUD_REQUEST
})

export const submitWordCloudSucceeded = wordCloud => ({
  type: SUBMIT_WORD_CLOUD_SUCCEEDED,
  wordCloud
})

export const submitWordCloudFailed = error => ({
  type: SUBMIT_WORD_CLOUD_FAILED,
  error
})

export const removeWordCloud = company => ({
  [REMOVE_WORD_CLOUD_FAILED]: {
    alert: {
      type: ERROR,
      message: 'Word cloud could not be removed. Please try again.'
    }
  },
  [CALL_API]: {
    types: [
      REMOVE_WORD_CLOUD_REQUEST,
      REMOVE_WORD_CLOUD_SUCCEEDED,
      REMOVE_WORD_CLOUD_FAILED
    ],
    endpoint: `companies/${company.id}/word_cloud.json`,
    requestType: REQUEST_DELETE,
    schema: NONE
  }
})

export const updateCompany = (id, attributes) => {
  return dispatch => {
    return dispatch(updateCompanyRequest(id, attributes)).then(action => {
      const { name } = action.response
      const dropdownOption = document.querySelector(
        '#current-company-name span'
      )
      const companyName = document.querySelector(
        '#current-company-name + .dropdown-menu .bold'
      )

      dropdownOption.innerText = name
      companyName.innerText = name
    })
  }
}

export const fetchCompanies = ({ page = 1, perPage = 30, query }) => ({
  [FETCH_COMPANIES_REQUEST]: { page, query },
  [CALL_API]: {
    types: [
      FETCH_COMPANIES_REQUEST,
      FETCH_COMPANIES_SUCCEEDED,
      FETCH_COMPANIES_FAILED
    ],
    endpoint: 'companies.json',
    requestType: REQUEST_GET,
    data: { page, perPage, query },
    dataGetter: data => data.companies,
    schema: COMPANY_COLLECTION
  }
})



// WEBPACK FOOTER //
// ../src/actions/companyActions.js